import React, { useEffect, useState } from "react";

import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import AssociationDetailsForm from "./AssociationDetailsForm";
import AuditableInfoButton from "../../../../components/common/form/AuditableInfoButton";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import ModalButton from "../../../../components/common/form/ModalButton";
import IconButton from "../../../../components/common/form/IconButton";
import { FaTrash } from "react-icons/fa";
import { useDeleteAssociationsByIdMutation, useGetAssociationByIdQuery } from "../associationApi";
import { Routes as AppRoutes } from "../../../../routes";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const AssociationDetailPage = () => {

  let { associationId } = useParams();

  const assocationsData = useGetAssociationByIdQuery(associationId);
  const [deleteApi, { isLoading }] = useDeleteAssociationsByIdMutation();
  const navigate = useNavigate();
  const [crumbs, setCrumbs] = useState<any[]>([])
  useEffect(() => {

    setCrumbs([
      { content: "Home", url: "/home" },
      { content: "Associations", url: "/associations" },
      { content: "Association Details", url: "" }
    ])

  }, []);

  const handleDelete = async () => {
    if (!associationId) return;

    try {
      await deleteApi(associationId).unwrap();
      navigate(AppRoutes.Association.path);
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };


  return (
    <>
      <div className="px-5 py-5" >
        <div className={"justify-between sm:block md:flex lg:flex"}>
          <Breadcrumb crumbs={crumbs} />
          <div className={"justify-between sm:block md:flex lg:flex"}>
            {hasPermission(["ASSOC-D"]) &&
              <ModalButton
                triggerButton={
                  <IconButton
                    icon={<FaTrash />}
                    title={"Delete Associations"}
                    hasBackground={true}
                    className="mr-2"
                  />
                }
                modal={
                  <ConfirmationModal
                    show={true}
                    setShow={() => {
                    }}
                    title={"Delete Associations"}
                    bodyMessage={"Are you sure you want to delete this Associations?"}
                    onSubmit={handleDelete}
                    isLoading={isLoading}
                  />
                }
              />
            }
            {hasPermission(["AUDIT-V"]) &&
              <AuditableInfoButton obj={assocationsData?.data} />}
          </div>
        </div >
        <AssociationDetailsForm />
      </div >
    </>
  );
};

export default AssociationDetailPage;